import { Input } from '@/components/Input';
import { selectPreviousAbn } from '@/context/borrower';
import { selectIsNZ } from '@/context/display';
import { useAppSelector } from '@/context/storeHooks';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'PreviousAbn';

export function PreviousAbn({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const currentState = useAppSelector(selectPreviousAbn);
    const isNZ = useAppSelector(selectIsNZ);

    // ***** Event Handlers *****
    function handleChange(): void {
        return;
    }

    // ***** Render *****
    return (
        <div data-testid={testId} className='w-full'>
            <Input
                title={isNZ ? 'Previous NZBN' : 'Previous ABN'}
                placeholder={currentState || '51 824 753 556'}
                showErrors={showErrors && !currentState}
                onChange={handleChange}
                id={`${baseId}-input-abn`}
                value={currentState ?? ''}
                disabled
            />
        </div>
    );
}
